import { statusColor, label } from "../lib/format";

export default function StatusBadge({ group, value, className = "" }) {
  if (!value) return <span className="text-slate-400 text-xs">—</span>;
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${statusColor(value)} ${className}`}
    >
      {group ? label(group, value) : value}
    </span>
  );
}
